import type { SaleTicket } from '@/types/sale';

type TicketNames = Pick<SaleTicket, 'id' | 'productName' | 'memberName'>;

/**
 * What a per-ticket print button calls a wristband: the member's name on a
 * group booking (so the cashier can hand each band to the right person), the
 * product otherwise. The server only sends `memberName` for group bookings.
 */
export function ticketLabel(t: TicketNames, fallback?: string): string {
  return t.memberName || t.productName || fallback || t.id;
}
